/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Retry_SendInputs */

const cs_chat_retry_send = /** @type {(inputs: Chat_Retry_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zkusit znovu`)
};

const en_chat_retry_send = /** @type {(inputs: Chat_Retry_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retry`)
};

/**
* | output |
* | --- |
* | "Retry" |
*
* @param {Chat_Retry_SendInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_retry_send = /** @type {((inputs?: Chat_Retry_SendInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Retry_SendInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_retry_send(inputs)
	return cs_chat_retry_send(inputs)
});